import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/visibility/layer.visibility.query.gql"
import type {
  LayerVisibilityQuery,
  LayerVisibilityQueryVariables,
} from "@/v2-backoffice-client/layer/visibility/__types__/layer.visibility.query"

type Options = QueryHookOptions<
  LayerVisibilityQuery,
  LayerVisibilityQueryVariables
>

export function useLayerVisibilityQuery(options?: Options) {
  return useQuery<LayerVisibilityQuery, LayerVisibilityQueryVariables>(
    query,
    options,
  )
}
